
// Importación de librerias del proyecto
import '@/plugins/vue-composition-api'
import Vue            from "vue";

import VueQuillEditor from 'vue-quill-editor';

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import App            from "./App.vue";
import router         from "./router";
import store          from "./store";
import * as Sentry    from "@sentry/vue";
import { alinearSesionJwt } from '@/utils/authSession';
import { estaMantenimientoActivo } from '@/config/mantenimiento';
import vuetify        from "./plugins/vuetify";
import VueResource    from "vue-resource";
import config         from 'dotenv';
import VueSweetalert2 from 'vue-sweetalert2';
import axios          from 'axios';
import { io }         from "socket.io-client";
import 'sweetalert2/dist/sweetalert2.min.css';
import 'vue-organization-chart/dist/orgchart.css';
import '@/assets/styles/twilio-whatsapp-filters.scss';
import Notifications from 'vue-notification'
import VueApexCharts from 'vue-apexcharts'
import { notifyBugReporterFromAxios, notifyBugReporterFromError } from '@/utils/bugReporter'
import {
  esErrorEncuestaTwilio,
  mensajeErrorEncuestaTwilio,
  notificarEncuestaPendiente,
} from '@/utils/encuestaTwilio'
import {
  esErrorAccesoBloqueado,
  mensajeErrorAccesoBloqueado,
  notificarAccesoBloqueadoActualizar,
} from '@/utils/accesoBloqueado';
if (process.env.VUE_APP_ENV === 'staging') {
  document.title = '[Ambiente] ' + (document.title || 'RH');
}

// Socket.IO al mismo host que api-rh (staging: wharecepinbi /wss, prod: escuelakpi /ws).
// Antes estaba hardcodeado a testfast.club → TwilioAgente no recibía mensajes en vivo.
const socketPath = process.env.VUE_APP_SOCKET_PATH || '/ws/socket.io'
const socketUrl = (process.env.VUE_APP_SOCKET_URL || 'https://escuelakpi.club').replace(/\/?$/, '/')

console.log('[socket-main] init', {
  socketUrl,
  socketPath,
  env: process.env.VUE_APP_ENV,
  nota: 'Socket KPI (tickets/alertas). WhatsApp en vivo usa socketTwilio → testfast',
})

const socket = io(socketUrl, {
  transports: ['websocket'],
  path: socketPath,
});

socket.on('connect', () => {
  console.log('[socket-main] CONNECT ok', { id: socket.id, socketUrl, socketPath })
})
socket.on('connect_error', (err) => {
  console.warn('[socket-main] CONNECT_ERROR', err && err.message)
})
// Los eventos WA (recibir-mensaje-twilio / twilio-unificado-bump) viven en mixinEstatusWha → socketTwilio (testfast)


// Configuración de herramientas
config.config();
Vue.config.productionTip = false;

// Sesión persistida sin JWT (o token huérfano): no dejar estado incoherente antes del primer render
alinearSesionJwt();


// Importar componentes de manera global
Vue.use(VueSweetalert2);
Vue.use(Notifications)
Vue.use(VueQuillEditor)

Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

// En local (localhost / LAN): proxy /api-rh/ → vue.config.js → Node :3004.
// En servidor (build prod o build:staging): VUE_APP_RUTA_API (ej. .../kpi-proxy/).
function normalizeApiBase(url) {
  if (!url || typeof url !== 'string') return url
  return url.endsWith('/') ? url : `${url}/`
}
function isLocalFrontendHost() {
  if (typeof window === 'undefined') return false
  const h = window.location.hostname
  if (h === 'localhost' || h === '127.0.0.1') return true
  if (/^192\.168\.\d{1,3}\.\d{1,3}$/.test(h)) return true
  if (/^10\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(h)) return true
  if (/^172\.(1[6-9]|2\d|3[0-1])\.\d{1,3}\.\d{1,3}$/.test(h)) return true
  return false
}
function resolveApiBaseUrl() {
  const configured = process.env.VUE_APP_RUTA_API

  if (isLocalFrontendHost()) {
    const direct = process.env.VUE_APP_DEV_RUTA_API
    if (direct && String(direct).trim()) {
      return normalizeApiBase(String(direct).trim())
    }
    return '/api-rh/'
  }

  if (configured && String(configured).trim()) {
    return normalizeApiBase(String(configured).trim())
  }
  if (process.env.NODE_ENV === 'development') {
    return '/api-rh/'
  }
  return undefined
}
if (process.env.NODE_ENV === 'production' && !process.env.VUE_APP_RUTA_API) {
  console.error(
    '[main] VUE_APP_RUTA_API no está definida en el build. Define .env.production y vuelve a ejecutar npm run build.'
  )
}
axios.defaults.baseURL = resolveApiBaseUrl()

// axios.interceptors.request.use(config => config);

// JWT (login /usuarios.data devuelve accessToken) + cabeceras de usuario para el API RH
axios.interceptors.request.use(config => {

  const u = store.state.login.datosUsuarioERP;
  const datosUsuarioERP = u && typeof u === 'object' ? u.iderp : u;
  const idUsuarioHeader =
    u && typeof u === 'object'
      ? (u.id_usuario != null && u.id_usuario !== '' ? String(u.id_usuario) : String(u.iderp != null ? u.iderp : ''))
      : '';

  const token = localStorage.getItem('accessToken') || localStorage.getItem('tlaKey');
  if (token) {
    config.headers.Authorization = 'Bearer ' + token;
  } else {
    delete config.headers.Authorization;
  }

  // No modificar headers para FormData (upload de archivos)
  if (config.data instanceof FormData) {
    // Backward compatible: algunas rutas legacy leían 'user-iD'
    config.headers['user-iD'] = datosUsuarioERP;
    // Nuevo estándar (api-rh): resolve-auth-user.js busca 'user-id' o 'id-usuario'
    if (datosUsuarioERP != null && String(datosUsuarioERP).trim() !== '') {
      config.headers['user-id'] = String(datosUsuarioERP);
    }
    if (idUsuarioHeader) config.headers['id-usuario'] = idUsuarioHeader;
    return config;
  }

  config.headers.Accept = 'application/json';
  config.headers['Access-Control-Allow-Origin'] = '*';
  config.headers['Access-Control-Allow-Methods'] = 'GET, POST, PUT, PATCH, DELETE';
  config.headers['Access-Control-Allow-Headers'] = 'Content-Type, Authorization';
  // Backward compatible: algunas rutas legacy leían 'user-iD'
  config.headers['user-iD'] = datosUsuarioERP;
  // Nuevo estándar (api-rh): resolve-auth-user.js busca 'user-id' o 'id-usuario'
  if (datosUsuarioERP != null && String(datosUsuarioERP).trim() !== '') {
    config.headers['user-id'] = String(datosUsuarioERP);
  }
  if (idUsuarioHeader) config.headers['id-usuario'] = idUsuarioHeader;

  return config;
}, error => {
  console.log( error )
  return Promise.reject(error);
});

function debeVolverAlLogin(error) {
  const status = error.response && error.response.status;
  const url = (error.config && error.config.url) || '';
  if (url.indexOf('usuarios.data') !== -1) {
    return false;
  }
  if (
    url.indexOf('password.forgot') !== -1 ||
    url.indexOf('password.forgot.email.save') !== -1 ||
    url.indexOf('password.forgot.email.verify') !== -1
  ) {
    return false;
  }
  if (url.includes('bug-reports')) {
    return false;
  }
  // 403 del bot IA o permiso puntual no implica sesión inválida
  if (status === 403 && url.indexOf('analyze-chat') !== -1) {
    return false;
  }
  if (status === 403 && error.response && error.response.data) {
    const data = error.response.data;
    if (data.code === 'ENCUESTA_TWILIO_PENDIENTE' || data.encuestaPendiente) {
      return false;
    }
    // 403 de permiso puntual (no sesión inválida)
    if (
      data.code === 'NOMINA_ADMIN_DENEGADA' ||
      data.code === 'ACCESO_BLOQUEADO' ||
      (typeof data.message === 'string' && data.message.toLowerCase().includes('no tienes permiso'))
    ) {
      return false;
    }
  }
  if (status === 401) {
    return true;
  }
  const msg = (error.response && error.response.data && error.response.data.message) || '';
  if (typeof msg !== 'string') {
    return false;
  }
  const m = msg.toLowerCase();
  // Respuestas típicas del middleware validar-usuario / sesión
  return (
    m.includes('inicia sesión') ||
    m.includes('iniciar sesión') ||
    m.includes('reinicia sesión') ||
    m.includes('reiniciar sesión') ||
    m.includes('token inválido') ||
    m.includes('autenticación') ||
    m.includes('authorization: bearer')
  );
}

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (esErrorEncuestaTwilio(error)) {
      notificarEncuestaPendiente(mensajeErrorEncuestaTwilio(error));
      notifyBugReporterFromAxios(error, { store, router });
      return Promise.reject(error);
    }

    if (esErrorAccesoBloqueado(error)) {
      // Alerta normal (Alerta.vue en App): sirve aunque quiten el overlay o aún no den F5
      notificarAccesoBloqueadoActualizar(mensajeErrorAccesoBloqueado(error));
      return Promise.reject(error);
    }

    if (debeVolverAlLogin(error)) {
      store.dispatch('login/salirLogin');
      const destino = estaMantenimientoActivo() ? 'Mantenimiento' : 'Login';
      router.replace({ name: destino }).catch(() => {});
    } else {
      notifyBugReporterFromAxios(error, { store, router });
    }
    return Promise.reject(error);
  }
);

// Aquí ponemos las variables globales
// Compatibilidad: módulos Vuex legacy usan Vue.http (vue-resource ya no está activo)
Vue.http = axios;
Vue.prototype.$http   = axios;
Vue.prototype.$socket = socket;

const sentryDsn = process.env.VUE_APP_SENTRY_DSN
const sentryRelease = process.env.VUE_APP_SENTRY_RELEASE
if (sentryDsn) {
  Sentry.init({
    Vue,
    dsn: sentryDsn,
    release: sentryRelease || undefined,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
    ],
    tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.2 : 1.0,
    environment: process.env.NODE_ENV,
  })

}

function setSentryUser(usuario) {
  if (!sentryDsn || !usuario || typeof usuario !== 'object') return
  Sentry.setUser({
    id: usuario.iderp != null ? String(usuario.iderp) : undefined,
    username: usuario.nombre_completo || usuario.nombre_usuario || undefined,
    ip_address: '{{auto}}',
  })
}

setSentryUser(store.state.login && store.state.login.datosUsuarioERP)
store.subscribe((mutation, state) => {
  if (mutation.type === 'login/DATOS_USUARIO') {
    setSentryUser(state.login && state.login.datosUsuarioERP)
  }
  if (mutation.type === 'login/SALIR' && sentryDsn) {
    Sentry.setUser(null)
  }
})

const previousVueErrorHandler = Vue.config.errorHandler
Vue.config.errorHandler = function(error, vm, info) {
  notifyBugReporterFromError(error, { store, router, source: 'vue', info })
  if (typeof previousVueErrorHandler === 'function') {
    previousVueErrorHandler.call(this, error, vm, info)
    return
  }
  console.error(error)
}

window.addEventListener('error', (event) => {
  notifyBugReporterFromError(event.error || event.message, {
    store,
    router,
    source: 'window.onerror',
    info: event.filename,
  })
})

window.addEventListener('unhandledrejection', (event) => {
  notifyBugReporterFromError(event.reason || 'Promise rechazada sin manejar', {
    store,
    router,
    source: 'unhandledrejection',
  })
})

if (estaMantenimientoActivo()) {
  store.dispatch('login/salirLogin');
}

// Constructor de VUE
new Vue({
  router,
  store,
  vuetify,
  render: function(h) {
    return h(App);
  },
}).$mount("#app");


